import React from 'react'
import { Route, Switch, useParams } from 'react-router-dom'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { FleetPage } from '../../../../shared/sso-workspace/fleet-page'
import { IconNotification } from '../../../../shared/icon/icon'
import { InboxPage } from './inbox-page'
import { PreferencesPage } from './preferences-page'
import { DeliveryLog } from '../../admin/notify/delivery-log'
import { TimelineView } from '../../admin/notify/timeline-page'

const OrgTimeline = () => {
  const { traceID } = useParams()
  return <TimelineView traceID={traceID} />
}

// The person's own notifications (everyone signed in; self-scoped, C-4) and
// the organization's notification activity: its own email and push
// deliveries, for everyone who can manage its users, super admins included
// (Email activity's rule, owner direction 2026-10-07: every organization's
// lives in the staff Notifications section). The server enforces the scope.
export const LayoutNotifications = () =>
  <Switch>
    <Route path="/org/notifications/preferences">
      <BreadcrumbView Icon={IconNotification} text="Notification preferences"><PreferencesPage /></BreadcrumbView>
    </Route>
    <Route path="/org/notifications" exact>
      <BreadcrumbView Icon={IconNotification} text="Notifications"><InboxPage /></BreadcrumbView>
    </Route>
    <Route path="/org/notification-activity/timeline/:traceID">
      <FleetPage title="Notification activity" purpose="One notification's path: who it went to, how and what happened.">
        <OrgTimeline />
      </FleetPage>
    </Route>
    <Route path="/org/notification-activity" exact>
      <BreadcrumbView Icon={IconNotification} text="Notification activity">
        <FleetPage title="Notification activity" purpose="Email and push notifications EducationXR sent for your organization and what happened to them.">
          <DeliveryLog />
        </FleetPage>
      </BreadcrumbView>
    </Route>
  </Switch>
